// extracted by mini-css-extract-plugin
export var contentWrapper = "eCardWidget-module--content-wrapper--57b27";
export var eCardWidget = "eCardWidget-module--eCardWidget--988b9";
export var waterMark = "eCardWidget-module--water-mark--7cb70";